import React from 'react';
import styled from 'styled-components';
import {Typography} from '@material-ui/core';
import SGBody from 'components/Typography/SGBody';
import ScanDetails, {ScanDetailKeys} from 'features/POSRegisters/interfaces/ScanDetails';
import {default as AlertComponent} from 'features/POSRegisters/components/Alert';
import {AlertType} from 'features/POSRegisters/interfaces/AlertInfo';
import type {default as Alert} from 'features/POSRegisters/interfaces/AlertInfo';

const StyledDataRow = styled.div`
  display: flex;
  gap: 16px;
  justify-content: start;
  border-bottom: 1px solid ${props => props.theme.grey}66;
  margin-bottom: 8px;
  padding-bottom: 8px;
  flex-wrap: wrap;
  &:last-child {
    margin-bottom: 8px;
  }
`;

const StyledDataCell = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin: 0;
  text-align: left;
  gap: 4px;
`;

const StyledTitle = styled(Typography)`
  font-family: 'Trade Gothic Bold Condensed';
  text-transform: uppercase;
  color: ${props => props.theme.subtleText};
  font-size: 12px;
  margin-bottom: 0px;
`;

const StyledCellValue = styled(SGBody)`
  && {
    line-height: 1;
  }
`;

export interface DataColumn {
  id: ScanDetailKeys;
  label: string;
  width: string;
  minWidth?: string;
  format?: (value: ScanDetails) => JSX.Element;
}

interface DataRowProps {
  columns: DataColumn[];
  data: ScanDetails | undefined;
  alerts?: Alert[] | undefined;
}

export default function DataRow({columns, data, alerts}: DataRowProps) {
  return (
    <StyledDataRow>
      {data !== undefined &&
        columns.map(column => {
          const key = column.id as keyof ScanDetails;
          const cellData = data[key] ? data[key] : '';

          return (
            <StyledDataCell
              key={column.id}
              style={{width: column.width ?? 'auto', minWidth: column.minWidth}}
            >
              <StyledTitle>{column.label}</StyledTitle>
              {column.format ? column.format(data) : <StyledCellValue>{cellData}</StyledCellValue>}
            </StyledDataCell>
          );
        })}

      {alerts?.map((alert, alertIdx) => {
        const rows = [{label: 'Issue', value: alert.description, fullWidth: true}];

        if (alert.alertType !== AlertType.SCAN_FAILURE_ALERT) {
          rows.push({label: 'Effect', value: alert.effect!, fullWidth: true});
          rows.push({label: 'Solution', value: `${alert.solution} ${alert.kb}`, fullWidth: true});
        }

        return (
          <AlertComponent
            key={`${data?.deviceName}${data?.deviceId}-alerts-${alertIdx}`}
            device={{scanResults: data!, alerts: [alert]}}
            alert={alert}
            rows={rows}
          />
        );
      })}
    </StyledDataRow>
  );
}
